"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Trigger = void 0;
var _Arrow = require("../Dropdown/Arrow.js");
var _index = require("../OverlayTrigger/index.js");
var _Overlay = require("../OverlayTrigger/Overlay.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Trigger = exports.Trigger = (0, _styledComponents["default"])(_index.OverlayTrigger).withConfig({
  displayName: "Trigger",
  componentId: "sc-1q7tqhp-0"
})(["display:block;", "{min-inline-size:0;inline-size:100%;transform:", ";}", "{", ";}"], _Overlay.Overlay, function (props) {
  return props.placement === 'bottom' ? 'translate(-50%, 8px)' : 'translate(-50%, -8px)';
}, _Arrow.Arrow, function (props) {
  return props.overlay && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
var _default = exports["default"] = Trigger;